<template>
  <v-toolbar fixed app dark color="#9C1A1A">
    <v-toolbar-side-icon @click.stop="toggleDrawer" v-if="authenticated"></v-toolbar-side-icon>
      <v-toolbar-title>
        <router-link :to="{ name: 'welcome' }" class="white--text">
          {{ appName }}
        </router-link>
    </v-toolbar-title>
    <v-spacer></v-spacer>

    <!-- Authenticated -->
    <template v-if="authenticated">
      <progress-bar :show="busy"></progress-bar>
      <!-- <v-btn flat v-if="authenticated" style="text-transform: none;">{{ saldo >= 0 ? 'CREDITO Bs' : 'DEUDA Bs' }} {{ saldo >= 0 ? new Intl.NumberFormat('de-DE').format(saldo) : new Intl.NumberFormat('de-DE').format(saldo * -1) }}</v-btn> -->
      <v-btn flat v-if="authenticated" :to="{ name: 'servicios-solvencia' }" style="text-transform: none;">{{ saldo >= 0 ? '' : 'DEUDA Bs' }} {{ saldo >= 0 ? '' : new Intl.NumberFormat('de-DE').format(saldo * -1) }}</v-btn>
      <!-- <v-btn v-if="filterRole(['administrador'])" flat icon>
        <v-badge v-model="show" overlap color="blue">
          <template v-slot:badge>
            <span>{{ total }}</span>
          </template>
          <v-icon>
            notifications
          </v-icon>
        </v-badge>
      </v-btn> -->
      <v-btn flat :to="{ name: 'settings.profile' }">{{ user.cpc ? user.cpc : '' }} {{ user.name }}</v-btn>
      <v-btn flat @click.prevent="logout">Salir</v-btn>
    </template>
  </v-toolbar>
</template>
<script>
import axios from 'axios'
import howler from 'howler'
import { mapGetters } from 'vuex'

export default {

  props: {
    drawer: {
      type: Boolean,
      required: true
    }
  },

  data: () => ({
    total: 0,
    show: false,
    appName: window.config.appName,
    busy: false
  }),

  computed: {
    ...mapGetters({
      user: 'authUser',
      authenticated: 'authCheck',
      saldo: 'getSaldoAgremiado',
    })
  },

  mounted () {
    // var sound = new Howl({
    //     src: '/notifications/to-the-point.mp3'
    // });
    this.getTotalRevision()
    this.$store.dispatch('fetchSaldo')
    // if(this.filterRole(['administrador'])){
      // this.sockets.subscribe('receiveNotificationAdmin', (data) => {
      //   console.log(data,'data del socket')
      //   this.total++
      //   this.show = true
      //   sound.play();
      //   // notificacion para nuevas actuaciones
      //   new Notification('Nueva Actuación', {
      //     body: data.name,
      //     icon: '/img/newlogo.png',
      //   });
      // });
    // }
  },

  methods: {

    async getTotalRevision() {
      await axios.get(`/api/sat/get-status-rape`).then(res => {
        this.show = res.data.revision == 0 ? false : true
        this.$nextTick(() => {
          this.total = res.data.revision
        })
      })
    },

    filterRole(role) {
      let exists = false
      exists = this.user.roles.filter(rol => {
        for (let index = 0; index < role.length; index++) {
          if(rol.slug === role[index]){
            return rol
          }
        }
      }).length != 0 ? true : false

      return exists
    },

    toggleDrawer () {
      this.$emit('toggleDrawer')
    },

    async logout () {
      this.busy = true

      if (this.drawer) {
        this.toggleDrawer()
      }

      // Log out the user.
      await this.$store.dispatch('logout')
      this.busy = false

      // Redirect to login.
      this.$router.push({ name: 'welcome' })
    }

  }
}
</script>

<style lang="stylus" scoped>

.toolbar__title .router-link-active
  text-decoration: none

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/ToolBar.vue